module.exports = "<a rel=\"nofollow\" (click)=\"dialogRef.close(false)\" class=\"pull-right pointer\"><i class=\"fa fa-close\"></i></a>\n<h1 mat-dialog-title>Confirm</h1>\n<div mat-dialog-content>{{confirmMessage}}</div>\n<div mat-dialog-actions class=\"row text-center\">\n    <button mat-button class=\"btn\" (click)=\"dialogRef.close(true)\">Confirm</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/dialogs/confirm/confirm.component.html
// module id = ../../../../../src/app/dialogs/confirm/confirm.component.html
// module chunks = main